import { AfterViewInit, Component, Input, OnDestroy } from '@angular/core';
import { HeaderColumn } from '../../model/header-column.model';
import { ApiCommunicationService } from '../../services/api-communication.service';
import { HelperService } from '../../services/helper.service';
import { HeaderType } from '../../model/header-type.enum';
import { IncidentsService } from '../../services/incidents.service';
import { ReportsService } from '../../services/reports.service';
import { ReferencedData } from '../../model/referenced-data.model';

@Component({
  selector: 'app-reference-data',
  templateUrl: './reference-data.component.html',
  styleUrls: ['./reference-data.component.scss']
})
export class ReferenceDataComponent implements AfterViewInit, OnDestroy {

  constructor(private apiCommunicationService: ApiCommunicationService,
              private incidentsService: IncidentsService,
              private reportsService: ReportsService) {
  }

  @Input()
  rowKey: string;

  @Input()
  rowData: any;

  data: any[] = [];
  headerColumns: HeaderColumn[] = [];
  allowedPageSizes = [5, 10, 'all'];
  pagerDisplayMode = 'full';

  ngAfterViewInit(): void {
    // console.log('init - ' + this.rowKey);
    this.setupGrid();
  }

  ngOnDestroy(): void {
    // console.log('destroy - ' + this.rowKey);
  }

  getGridWidth(): string {
    return 'calc(100vw - 390px)';
  }

  edit(data: any): void {
    this.setFormEditMode(data);
  }

  rowDblClick(event: any): void {
    this.setFormEditMode(event.data);
  }

  getRowImage(data: any): string {
    const headerType: HeaderType = HeaderType[HeaderType[data.Type]];
    const image = headerType === HeaderType.REPORTS ? 'Report' : 'Incident';
    return `../../assets/images/main-menu/${image}.svg`;
  }

  private setFormEditMode(data): void {
    if (data.Type !== undefined && data.K3VRowKey !== undefined) {
      const headerType: HeaderType = HeaderType[HeaderType[data.Type]];
      if (headerType === HeaderType.REPORTS) {
        this.reportsService.editReportNotify(data.K3VRowKey);
      } else if (headerType === HeaderType.INCIDENTS) {
        this.incidentsService.editIncidentNotify(data.K3VRowKey);
      }
    }
  }

  private setupGrid(): void {
    if (this.rowData.Type !== undefined) {
      const parentHeaderType: HeaderType = HeaderType[HeaderType[this.rowData.Type]];
      let headerType: HeaderType;
      if (parentHeaderType === HeaderType.REPORTS) {
        headerType = HeaderType.INCIDENTS;
      } else if (parentHeaderType === HeaderType.INCIDENTS) {
        headerType = HeaderType.REPORTS;
      }
      if (headerType !== undefined) {
        this.apiCommunicationService.getGridColumns(headerType).subscribe(columns => {
          columns.HeaderColumns.forEach(item => item.FieldName = item.FieldName.toUpperCase());
          this.headerColumns = columns.HeaderColumns.filter(column => column.IsVisible).sort(HelperService.sortGridHeaders);
          this.apiCommunicationService.getReferencedData(this.rowKey, parentHeaderType).subscribe(referencedData => {
            if (referencedData !== undefined && referencedData !== null && referencedData.Records !== undefined && referencedData.Records !== null) {
              this.setGridData(referencedData);
            }
          });
        });
      }
    }
  }

  private setGridData(referencedData: ReferencedData): void {
    const data: any[] = [];
    referencedData.Records.forEach(content => {
      const dataItem = {
        Type: content.Type,
        K3VRowKey: content.K3VRowKey
      };
      content.Fields.forEach(field => {
        dataItem[field.FieldName.toUpperCase()] = field.Value;
      });
      data.push(dataItem);
    });
    this.data = data;
  }
}
